"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRTLString = void 0;
var constants_1 = require("./constants");
/**
 * This module is a collection of functions to deal with strings.
 * Usage:
 * `import { functionName } from 'priority_utils/lib/strings'`
 *
 *
 * @module strings
 * @preferred
 *
 */
/**
 * concat takes strings as args and concats all strings that are not undefined
 * @param args unlimited strings to concat all together
 *
 * @category String
 */
function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.filter(function (s) { return s; }).reduce(function (str, s) { return str + s; }, '');
}
/**
 * concatAll takes strings as args,
 * if all strings have values
 * returns the concatonated string
 * otherwise returns an empty string and concats only the strings that are not undefined
 * @param args unlimited strings to concat all together
 *
 * @category String
 */
function concatAll() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var strings = args.filter(function (s) { return s; });
    return strings.length ? strings.reduce(function (str, s) { return str + s; }, '') : '';
}
/**
 *
 * @param stringVal
 * @category String
 */
function capitalize(stringVal) {
    return stringVal.charAt(0).toUpperCase() + stringVal.slice(1);
}
/**
 *
 * @param stringVal
 * @category String
 */
function capitalizeAll(stringVal) {
    return stringVal
        .split(' ')
        .map(function (s) { return s.charAt(0).toUpperCase() + s.slice(1); })
        .join(' ');
}
/**
 *
 * @param str
 * @category String
 */
var replacePattern = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
function isRTLString(str) {
    if (str === void 0) { str = ''; }
    var preparedString = str.trim().replace(replacePattern, '');
    return new RegExp('[' + constants_1.rtlChars + ']', 'gi').test(preparedString);
}
exports.isRTLString = isRTLString;
